// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"TextComponent_themeRoot__2KB5K","gwMediaSidebarTextContainer":"TextComponent_gwMediaSidebarTextContainer__38bnP"};